import * as React from "react"
import type { SVGProps } from "react"
const SvgTrendingDownMini = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 16 16"
    {...props}
  >
    <path d="M1.32 3.83a.96.96 0 0 0-.04 1.4l3.27 3.22q.59.58 1.38.58.8 0 1.39-.58l1.15-1.13 2.7 2.71h-.79q-.4 0-.69.3-.3.27-.29.68 0 .4.29.7t.7.29h3.16q.4 0 .7-.29.28-.29.28-.7V7.88q0-.4-.28-.7a1 1 0 0 0-.7-.29q-.4 0-.7.29-.28.28-.28.68v.8L9.85 5.93a2 2 0 0 0-1.38-.58q-.8 0-1.39.58L5.93 7.08 2.7 3.83a.95.95 0 0 0-1.38 0" />
  </svg>
)
export default SvgTrendingDownMini
